import React, {useState} from 'react';
import {Button, Checkbox, Form, Input, Modal, Table, theme} from "antd";
import {ColumnsType} from "antd/es/table";
import {QueryKey, useQueryClient} from "@tanstack/react-query";

import {useCommonUseMutation, useCommonUseQuery} from "../../../../../Common/hooks/rest/ReacQueryHook";
import {procAdminService} from "../../../../../Common/util/ProcService";
import {EditOutlined} from "@ant-design/icons";
import {TB_SAPJCO_CONFIG} from "./data/TB_SAPJCO_CONFIG";

const SapMgr: React.FC = () => {
    const { token: { colorBgContainer },} = theme.useToken();
    const queryClient = useQueryClient();
    const queryKey:QueryKey =   [`TB_SAPJCO_CONFIG`];

    const serviceCode:string       =   process.env.REACT_APP_SERVICE_NAME as string;

    const mutateUpdate = useCommonUseMutation<any>(queryKey, queryClient
        , procAdminService);

    const { data, isFetching} = useCommonUseQuery<TB_SAPJCO_CONFIG[]>(
        queryKey,
        () =>procAdminService<TB_SAPJCO_CONFIG[]>("post", `${serviceCode}ADS23`, null));

    const [showConfirmBox, setShowConfirmBox] = useState<boolean>(false);
    const [showModal, setShowModal] = useState<boolean>(false);

    const [jcoKey, setJcoKey] = useState<number>(-1);
    const [mshost, setMshost] = useState<string>('');
    const [msserv, setMsserv] = useState<string>('');
    const [r3name, setR3name] = useState<string>('');
    const [ashost, setAshost] = useState<string>('');
    const [gwhost, setGwhost] = useState<string>('');
    const [gwserv, setGwserv] = useState<string>('');
    const [group, setGroup] = useState<string>('');
    const [client, setClient] = useState<string>('');
    const [sysnr, setSysnr] = useState<string>('');
    const [userId, setUserId] = useState<string>('');
    const [passwd, setPasswd] = useState<string>('');
    const [lang, setLang] = useState<string>('');
    const [poolCapacity, setPoolCapacity] = useState<number>(-1);
    const [poolCheckConnection, setPoolCheckConnection] = useState<string>('');
    const [expirationTime, setExpirationTime] = useState<number>(0);
    const [roundTripOptimization, setRoundTripOptimization] = useState<string>('0');
    const [poolLimitCount, setPoolLimitCount] = useState<number>(1);


    const onDelete = (record:TB_SAPJCO_CONFIG) => {

        Modal.confirm({
            title: `SAP 계정정보 설정을 삭제하시겠습니까?`,
            content: "주의 : 시스템에 영향이 미칠 수 있습니다.",
            open: showConfirmBox,
            okText: "확인",
            cancelText: "취소",
            onOk() {
                setShowConfirmBox(false);
                const updateParam = { method: 'post', serviceCode: `${serviceCode}ADD02`, requestBody:record }
                return mutateUpdate.mutateAsync(updateParam)
                    .catch(error => {
                        console.error(error);
                    }).finally(() => {
                    });
            },
            onCancel() {
                setShowConfirmBox(false);
            },
        });

    };


    function onSaveJcoConnInfo()
    {
        const request:TB_SAPJCO_CONFIG = {
            jcoKey:jcoKey,
            mshost:mshost,
            msserv:msserv,
            r3name:r3name,
            ashost:ashost,
            gwhost:gwhost,
            gwserv:gwserv,
            group:group,
            client:client,
            sysnr:sysnr,
            userId:userId,
            passwd:passwd,
            lang:lang,
            poolCapacity:poolCapacity,
            poolCheckConnection:poolCheckConnection,
            expirationTime:expirationTime,
            roundTripOptimization:roundTripOptimization,
            poolLimitCount:poolLimitCount,
        }

        Modal.confirm({
            title: `SAP 계정 정보를 저장하시겠습니까?`,
            content: "주의 : 시스템에 영향이 미칠 수 있습니다.",
            open: showConfirmBox,
            okText: "확인",
            cancelText: "취소",
            onOk() {
                setShowModal(false);
                const updateParam = { method: 'post', serviceCode: `${serviceCode}ADU08`, requestBody:request }
                return mutateUpdate.mutateAsync(updateParam)
                    .catch(error => {
                        console.error(error);

                    }).finally(() => {
                    });
            },
            onCancel() {
                setShowModal(false);
            },
        });
    }



    const onRegiModal= () => {
        setMshost('');
        setMsserv('');
        setR3name('');
        setAshost('');
        setGwhost('');
        setGwserv('');
        setGroup('');
        setClient('');
        setSysnr('');
        setUserId('');
        setPasswd('');
        setLang('');
        setExpirationTime(1800);
        setPoolCapacity(100);
        setPoolCheckConnection('1');
        setShowModal(true);
        setRoundTripOptimization('0');
        setPoolLimitCount(1);
    }

    const onModifyModal= (record:TB_SAPJCO_CONFIG) => {
        setJcoKey(record.jcoKey);
        setMshost(record.mshost);
        setMsserv(record.msserv);
        setR3name(record.r3name);
        setAshost(record.ashost);
        setGwhost(record.gwhost);
        setGwserv(record.gwserv);
        setGroup(record.group);
        setClient(record.client);
        setSysnr(record.sysnr);
        setUserId(record.userId);
        setPasswd('');
        setLang(record.lang);
        setExpirationTime(record.expirationTime);
        setPoolCapacity(record.poolCapacity);
        setPoolCheckConnection(record.poolCheckConnection);
        setRoundTripOptimization(record.roundTripOptimization);
        setPoolLimitCount(record.poolLimitCount);
        setShowModal(true);

    }


    const columns: ColumnsType<TB_SAPJCO_CONFIG> = [
        {
            title: '',
            dataIndex: 'jcoKey',
            key: 'jcoKey',
            render: (id: number) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {id}
                </div>
        },
        {
            title: '접속IP',
            dataIndex: 'ashost',
            key: 'ashost',
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {text}
                </div>
        },
        {
            title: '클라이언트',
            dataIndex: 'client',
            key: 'client',
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {text}
                </div>
        },
        {
            title: 'ID',
            dataIndex: 'userId',
            key: 'userId',
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {text}
                </div>
        },
        {
            title: '비밀번호',
            dataIndex: 'passwd',
            key: 'passwd',
            ellipsis:true,
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {text}
                </div>
        },
        {
            title: 'R3명',
            dataIndex: 'r3name',
            key: 'r3name',
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {text}
                </div>
        },
        {
            title: '인스턴스번호',
            dataIndex: 'sysnr',
            key: 'sysnr',
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {text}
                </div>

        },

        {
            title: '만료시간(초)',
            dataIndex: 'expirationTime',
            key: 'expirationTime',
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {text}
                </div>

        },
        {
            title: '언어',
            dataIndex: 'lang',
            key: 'lang',
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {text}
                </div>

        },
        {
            title: '커넥션풀개수',
            dataIndex: 'poolCapacity',
            key: 'poolCapacity',
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {text}
                </div>

        },
        {
            title: '연결체크',
            dataIndex: 'poolCheckConnection',
            key: 'poolCheckConnection',
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Checkbox checked={text === '1' ? true : false}/>
                </div>

        },
        {
            title: '그룹',
            dataIndex: 'group',
            key: 'group',
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {text}
                </div>

        },
        {
            title: '메세지서버IP',
            dataIndex: 'mshost',
            key: 'mshost',
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {text}
                </div>

        },
        {
            title: '메세지서버명',
            dataIndex: 'msserv',
            key: 'msserv',
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {text}
                </div>

        },
        {
            title: '게이트웨이IP',
            dataIndex: 'gwhost',
            key: 'gwhost',
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {text}
                </div>

        },
        {
            title: '게이트웨이명',
            dataIndex: 'gwserv',
            key: 'gwserv',
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {text}
                </div>

        },

        {
            title: '',
            key: 'Active',
            dataIndex: 'Active',
            render: (text, record:TB_SAPJCO_CONFIG) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Button type="link" size="small" onClick={() => {onModifyModal(record)}}>수정</Button>
                    <Button type="link" size="small" onClick={() => {onDelete(record)}}>삭제</Button>
                </div>

        },

    ];





    const fields = [
        { name: ['jcoKey'], value: jcoKey },
        { name: ['mshost'], value: mshost },
        { name: ['msserv'], value: msserv },
        { name: ['r3name'], value: r3name },
        { name: ['ashost'], value: ashost },
        { name: ['gwhost'], value: gwhost },
        { name: ['gwserv'], value: gwserv },
        { name: ['group'], value: group },
        { name: ['client'], value: client },
        { name: ['sysnr'], value: sysnr },
        { name: ['userId'], value: userId },
        { name: ['passwd'], value: passwd },
        { name: ['lang'], value: lang },
        { name: ['poolCapacity'], value: poolCapacity },
        { name: ['poolCheckConnection'], value: poolCheckConnection },
        { name: ['expirationTime'], value: expirationTime },
        { name: ['roundTripOptimization'], value: roundTripOptimization },
        { name: ['poolLimitCount'], value: poolLimitCount },
    ];

    return (
        <>
        <nav style={{
            margin:'0px 0px 14px 0px',
            padding:'9px 8px 9px 0px',
            height: '50px',
            display:'flex',
            justifyContent: "space-between",
            alignItems:'center',
            borderRadius: "8px", // 라운드 처리 추가
            border: '1px solid #dadada',
            background: colorBgContainer,
        }}>
            <div style={{ display: "flex", alignItems: "center" }}>
                <div style={{
                    padding: '9px 5px',
                    display:'flex',
                }}>
                </div>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
                <Button style={{marginRight:"10px"}} type={"primary"} onClick={onRegiModal}>SAP계정등록</Button>
            </div>
        </nav>
        <Table columns={columns}
                dataSource={data}
                rowKey="jcoKey"
                loading={isFetching}
        />

            <Modal
                open={showModal}
                title={"SAP 접속정보"}
                onCancel={()=>{setShowModal(false)}}
                footer={[
                    <></>
                ]}
            >
                <Form
                    name="saveJCoInfo"
                    fields={fields}
                    initialValues={{
                        remember: false,
                    }}
                    onFinish={onSaveJcoConnInfo}
                >
                    <Form.Item
                        label={"접속IP"}
                        name="ashost"
                        rules={[
                            {
                                required : true,
                            },
                        ]}
                    >
                        <Input
                            prefix={<EditOutlined className="site-form-item-icon" />}
                            placeholder="접속IP"
                            value={ashost}
                            onChange={(e)=> setAshost(e.target.value)}
                        />
                    </Form.Item>
                    <Form.Item
                        label={"Client"}
                        name="client"
                        rules={[
                            {
                                required : true,
                            },
                        ]}
                    >
                        <Input
                            prefix={<EditOutlined className="site-form-item-icon" />}
                            placeholder="Client"
                            value={client}
                            onChange={(e)=> setClient(e.target.value)}
                        />
                    </Form.Item>
                    <Form.Item
                        label={"인터페이스ID"}
                        name="userId"
                        rules={[
                            {
                                required : true,
                            },
                        ]}
                    >
                        <Input
                            prefix={<EditOutlined className="site-form-item-icon" />}
                            placeholder="인터페이스ID"
                            value={userId}
                            onChange={(e)=> setUserId(e.target.value)}
                        />
                    </Form.Item>
                    <Form.Item
                        label={"비밀번호"}
                        name="passwd"
                        rules={[
                            {
                                required : true,
                            },
                        ]}
                    >
                        <Input
                            prefix={<EditOutlined className="site-form-item-icon" />}
                            placeholder="비밀번호"
                            type="password"
                            value={passwd}
                            onChange={(e)=> setPasswd(e.target.value)}
                        />
                    </Form.Item>
                    <Form.Item
                        label={"R3명"}
                        name="r3name"
                        rules={[
                            {
                                required : false,
                            },
                        ]}
                    >
                        <Input
                            prefix={<EditOutlined className="site-form-item-icon" />}
                            placeholder="R3명"
                            value={r3name}
                            onChange={(e)=> setR3name(e.target.value)}
                        />
                    </Form.Item>
                    <Form.Item
                        label={"인스턴스번호"}
                        name="sysnr"
                        rules={[
                            {
                                required : true,
                            },
                        ]}
                    >
                        <Input
                            prefix={<EditOutlined className="site-form-item-icon" />}
                            placeholder="인스턴스번호"
                            value={sysnr}
                            onChange={(e)=> setSysnr(e.target.value)}
                        />
                    </Form.Item>
                    <Form.Item
                        label={"만료시간(초)"}
                        name="expirationTime"
                        rules={[
                            {
                                required : true,
                            },
                        ]}
                    >
                        <Input
                            prefix={<EditOutlined className="site-form-item-icon" />}
                            placeholder="만료시간(초)"
                            value={expirationTime}
                            type="number"
                            onChange={(e)=> setExpirationTime( parseInt(e.target.value) )}
                        />
                    </Form.Item>

                    <Form.Item
                        label={"언어"}
                        name="lang"
                        rules={[
                            {
                                required : false,
                            },
                        ]}
                    >
                        <Input
                            prefix={<EditOutlined className="site-form-item-icon" />}
                            placeholder="언어"
                            value={lang}
                            onChange={(e)=> setLang(e.target.value)}
                        />
                    </Form.Item>
                    <Form.Item
                        label={"커넥션풀개수"}
                        name="poolCapacity"
                        rules={[
                            {
                                required : false,
                            },
                        ]}
                    >
                        <Input
                            prefix={<EditOutlined className="site-form-item-icon" />}
                            placeholder="커넥션풀개수"
                            value={poolCapacity}
                            type="number"
                            onChange={(e)=> setPoolCapacity( parseInt( e.target.value ))}
                        />
                    </Form.Item>
                    <Form.Item
                        label={"연결체크"}
                        name="poolCheckConnection"
                        rules={[
                            {
                                required : false,
                            },
                        ]}
                    >
                        <Checkbox checked={ poolCheckConnection === '1' ? true : false} onChange={(e)=> setPoolCheckConnection(e.target.checked ? '1' : '0')}/>
                    </Form.Item>
                    <Form.Item
                        label={"그룹"}
                        name="group"
                        rules={[
                            {
                                required : false,
                            },
                        ]}
                    >
                        <Input
                            prefix={<EditOutlined className="site-form-item-icon" />}
                            placeholder="그룹"
                            value={group}
                            onChange={(e)=> setGroup(e.target.value)}
                        />
                    </Form.Item>
                    <Form.Item
                        label={"메시지서버IP"}
                        name="mshost"
                        rules={[
                            {
                                required : false,
                            },
                        ]}
                    >
                        <Input
                            prefix={<EditOutlined className="site-form-item-icon" />}
                            placeholder="메시지서버IP"
                            value={mshost}
                            onChange={(e)=> setMshost(e.target.value)}
                        />
                    </Form.Item>
                    <Form.Item
                        label={"메시지서버명"}
                        name="msserv"
                        rules={[
                            {
                                required : false,
                            },
                        ]}
                    >
                        <Input
                            prefix={<EditOutlined className="site-form-item-icon" />}
                            placeholder="메시지서버명"
                            value={msserv}
                            onChange={(e)=> setMsserv(e.target.value)}
                        />
                    </Form.Item>
                    <Form.Item
                        label={"게이트웨이IP"}
                        name="gwhost"
                        rules={[
                            {
                                required : false,
                            },
                        ]}
                    >
                        <Input
                            prefix={<EditOutlined className="site-form-item-icon" />}
                            placeholder="게이트웨이IP"
                            value={gwhost}
                            onChange={(e)=> setGwhost(e.target.value)}
                        />
                    </Form.Item>
                    <Form.Item
                        label={"게이트웨이명"}
                        name="gwserv"
                        rules={[
                            {
                                required : false,
                            },
                        ]}
                    >
                        <Input
                            prefix={<EditOutlined className="site-form-item-icon" />}
                            placeholder="게이트웨이명"
                            value={gwserv}
                            onChange={(e)=> setGwserv(e.target.value)}
                        />
                    </Form.Item>
                    <Form.Item
                        label={"최저 커넥션수"}
                        name="poolLimitCount"
                        rules={[
                            {
                                required : false,
                            },
                        ]}
                    >
                        <Input
                            prefix={<EditOutlined className="site-form-item-icon" />}
                            placeholder="최저 커넥션수"
                            value={poolLimitCount}
                            onChange={(e)=> setPoolLimitCount(parseInt(e.target.value))}
                        />
                    </Form.Item>
                    <Form.Item
                        label={"GET_RFC_METADATA 호출여부"}
                        name="roundTripOptimization"
                        rules={[
                            {
                                required : false,
                            },
                        ]}
                    >
                        <Input
                            prefix={<EditOutlined className="site-form-item-icon" />}
                            placeholder="GET_RFC_METADATA 호출여부"
                            value={roundTripOptimization}
                            onChange={(e)=> setRoundTripOptimization(e.target.value)}
                        />
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" htmlType="submit" className="login-form-button">
                            적용
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};

export default SapMgr;
